import { useEffect, useState } from "react";
import { Button, Spinner, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import userTemplatesApi from "../../../api/userTemplatesApi";
import Pagination from "../../../components/Pagination";

const UserdefinedTemplates = () => {
  const [userDefinedTemplates, setUserDefinedTemplates] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.userId;

  // console.log("User:", user);
  // console.log("UserId:", userId);

  useEffect(() => {
    const fetchUserDefinedTemplates = async () => {
      setLoading(true);
      try {
        const response = await userTemplatesApi.getTemplatesByUserId(
          userId,
          page,
          pageSize,
          sortedColumn,
          sortOrder,
        );
        console.log("API Response:", response);

        setUserDefinedTemplates(response.data.content || []);
        setTotalPages(response.data.totalPages || 0);
      } catch (err) {
        console.error("Error fetching user-defined templates:", err);
        setError("Failed to load templates. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    if (userId) fetchUserDefinedTemplates();
  }, [userId, page, pageSize, sortedColumn, sortOrder]);

  const downloadFile = (template) => {
    const byteCharacters = atob(template.file);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: template.fileType });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = template.documentName;
    link.click();
  };
  if (loading) return <Spinner animation="border" />;

  if (error) return <p className="text-danger">{error}</p>;
  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));
    setPage(selectedPage);
    localStorage.setItem("userCollabs", selectedPage);
  };

  const handleSort = (column) => {
    if (sortedColumn === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortedColumn(column);
      setSortOrder("asc");
    }
  };

  const createNewCollab = async (template) => {
    try {
      const documents = template.file
        ? [
            {
              documentName: template.documentName || "Untitled",
              description: template.description || "",
              file: template.file,
              fileType: template.fileType || "application/octet-stream",
            },
          ]
        : [];

      const checklist = Array.isArray(template.checklistItems)
        ? template.checklistItems
        : template.checklistItems
          ? template.checklistItems.split(",").map((item) => item.trim())
          : [];

      navigate("/dashboard/my-collabs/new-collab", {
        state: {
          collaborationName: template.collaborationName || "",
          documents,
          fileName: documents.length > 0 ? documents[0].documentName : "",
          description: documents.length > 0 ? documents[0].description : "",
          file: documents.length > 0 ? documents[0].file : null,
          checklist,
        },
      });
    } catch (err) {
      console.error("Failed to prepare template for new collaboration:", err);
    }
  };
  return (
    <div className="p-3">
      <h4>User Defined Templates</h4>

      {userDefinedTemplates.length === 0 ? (
        <p>No templates available</p>
      ) : (
        <div style={{ overflowX: "auto", width: "100%" }}>
          <Table
            striped
            bordered
            hover
            responsive
            style={{ minWidth: "1100px", whiteSpace: "nowrap" }}
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Description</th>
                <th>Checklist</th>
                <th>File</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {userDefinedTemplates.map((template, index) => (
                <tr key={template.id}>
                  <td>{index + 1}</td>
                  <td>{template.collaborationName}</td>
                  <td>{template.description}</td>
                  <td>{template.checklistItems}</td>
                  <td>
                    {template.file ? (
                      <Button size="sm" onClick={() => downloadFile(template)}>
                        {template.documentName || "Download"}
                      </Button>
                    ) : (
                      "None"
                    )}
                  </td>
                  <td>{template.createdAt}</td>
                  <td>
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => createNewCollab(template)}
                    >
                      Create
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
      {userDefinedTemplates.length > 0 && totalPages > 0 && (
        <div style={{ marginTop: "auto" }}>
          <Pagination
            page={page}
            pageSize={pageSize}
            totalPages={totalPages}
            handlePageSizeChange={handlePageSizeChange}
            handlePageClick={handlePageClick}
          />
        </div>
      )}
    </div>
  );
};

export default UserdefinedTemplates;
